module.exports = __webpack_public_path__ + "static/CameraMate@2x-fde937d26d641daf5781e15f6c3bca9f.jpg";